module.exports = __webpack_public_path__ + "static/media/Shipped-OnItsWay.11a82980.svg";